import baseMessages from "./pt-BR.json";

function flatten(obj: Record<string, any>, prefix = ""): Record<string, string> {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "object" && value !== null) {
      Object.assign(acc, flatten(value, fullKey));
    } else {
      acc[fullKey] = value;
    }
    return acc;
  }, {} as Record<string, string>);
}

const flatBase = flatten(baseMessages);

/**
 * Carrega as traduções base e faz merge com os overrides do cliente, se existirem.
 *
 * Para adicionar overrides de um cliente, crie o arquivo:
 *   src/i18n/clientes/<guid_client>/pt-BR.json
 *
 * Exemplo:
 *   src/i18n/clientes/a1b2c3d4-e5f6-7890-abcd-ef1234567890/pt-BR.json
 *   {
 *     "dashboard": {
 *       "renewedCertificatesPerGroup": {
 *         "groupLabel": "negócio"
 *       }
 *     }
 *   }
 */
export async function loadMessages(guid_client: string | undefined): Promise<Record<string, string>> {
  if (!guid_client) {
    return flatBase;
  }

  try {
    const clientMessages = await import(`./clientes/${guid_client}/pt-BR.json`);
    return { ...flatBase, ...flatten(clientMessages.default) };
  } catch {
    return flatBase;
  }
}
